import React from 'react';
import { useTranslation } from 'react-i18next';
import { Facebook, Youtube, Twitter } from 'lucide-react';
import logoBlack from '../assets/images/ksu_logo_black.png';
import vision2030 from '../assets/images/vision2030.svg';

const Footer = () => {
    const { t, i18n } = useTranslation();
    const isAr = i18n.language === 'ar';

    const socialLinks = [
        { icon: <Facebook size={22} />, href: "https://www.facebook.com/King.Saud.University", label: t('footer.facebook') },
        { icon: <Twitter size={22} />, href: "https://x.com/_KSU/", label: t('footer.twitter') },
        { icon: <Youtube size={22} />, href: "https://www.youtube.com/user/pdksuchannel", label: t('footer.youtube') },
    ];

    const legalLinks = [
        { name: t('footer.copyrightLink'), href: "https://ksu.edu.sa/copyright" },
        { name: t('footer.privacyPolicy'), href: "https://ksu.edu.sa/privacy" },
        { name: t('footer.termsOfUse'), href: "https://ksu.edu.sa/terms" },
    ];

    return (
        <footer className="w-full bg-[#F3F4F6] pt-12 pb-4 border-t border-gray-200 mt-auto font-ibm-plex-sans-arabic">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

                {/* Row 1: Contact & Social */}
                <div className={`flex flex-col gap-6 mb-8`}>
                    <h3 className="text-xl font-bold text-gray-800">{t('footer.contactUs')}</h3>
                    <div className={`flex items-center gap-5`}>
                        {socialLinks.map((social, index) => (
                            <a
                                key={index}
                                href={social.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-10 h-10 flex items-center justify-center rounded-full bg-white text-gray-500 hover:bg-[#006C35] hover:text-white transition-all duration-300 shadow-sm border border-gray-100"
                                aria-label={social.label}
                            >
                                {social.icon}
                            </a>
                        ))}
                    </div>
                </div>

                {/* Divider */}
                <div className="w-full h-px bg-gray-200 mb-8"></div>

                {/* Row 2: Copyright & Logo */}
                <div className={`flex flex-col md:flex-row justify-between items-center gap-8 mb-8`}>

                    {/* Copyright & Last Modified */}
                    <div className={`space-y-2`}>
                        <p className="text-[12px] text-gray-700 font-bold">
                            {t('footer.copyright')}
                        </p>
                        <p className="text-[12px] text-gray-400 font-medium">
                            {t('footer.lastModified')}
                        </p>
                    </div>

                    {/* Logo */}
                    <div className={`flex items-center gap-4`}>
                        <div className="w-36 lg:w-32">
                            <img
                                src={logoBlack}
                                alt={t('navbar.logoAlt')}
                                className="w-full h-auto"
                                />
                        </div>
                        <a href="https://www.vision2030.gov.sa/ar" target="_blank" rel="noopener noreferrer" className="w-36 lg:w-32">
                            <img
                                src={vision2030}
                                alt="vision"
                                className="w-full h-auto"
                            />
                        </a>
                    </div>
                </div>

                {/* Row 3: Legal Links (Bottom) */}
                <div className="w-full h-px bg-gray-200 mb-2"></div>
                <div className={`flex flex-wrap justify-center md:justify-end gap-4`}>
                    {legalLinks.map((link, index) => (
                        <a
                            key={index}
                            href={link.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-xs underline text-gray-500 hover:text-[#006C35] transition-colors font-medium"
                        >
                            {link.name}
                        </a>
                    ))}
                </div>
            </div>
        </footer>
    );
};

export default Footer;
